/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Design_Settings_SavedInputs */

const en_admin_design_settings_saved = /** @type {(inputs: Admin_Design_Settings_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings saved.`)
};

const de_admin_design_settings_saved = /** @type {(inputs: Admin_Design_Settings_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen gespeichert.`)
};

/**
* | output |
* | --- |
* | "Settings saved." |
*
* @param {Admin_Design_Settings_SavedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_design_settings_saved = /** @type {((inputs?: Admin_Design_Settings_SavedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Design_Settings_SavedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_design_settings_saved(inputs)
	return en_admin_design_settings_saved(inputs)
});